import { axiosService } from "@picovico/helpers";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { getLocalStorageData } from "@picovico/utils";

function useLogin() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<null | unknown>(null);
  const [data, setData] = useState<null | unknown>(null);

  useEffect(() => {
    const token = getLocalStorageData("token");
    setIsLoading(true);
    if (token) {
      axiosService({
        name: "user_profile",
        method: "get",
        headers: {
          Authorization: token,
        },
      })
        .then((res) => {
          if (res?.data?.data) {
            setData(res?.data?.data);
            router.pathname === "/login" && router.push("/");
          }
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [router]);

  return { isLoading, error, data };
}

export default useLogin;
